import type { CshGroupDetail } from "../../services/csh/csh.types";

export interface HomeSiteScope {
    siteIds: number[];
    siteGuids: string[];
    siteIdentifiers: string[];
}

export const EMPTY_HOME_SITE_SCOPE: HomeSiteScope = { siteIds: [], siteGuids: [], siteIdentifiers: [] };

export function parseCshGroupIds(value: string | null): string[] {
    return [...new Set((value ?? "").split(",").map(id => id.trim()).filter(Boolean))];
}

export function buildHomeSiteScope(details: CshGroupDetail[]): HomeSiteScope {
    const ids = new Set<number>();
    const guids = new Set<string>();
    const identifiers = new Set<string>();
    details.forEach(detail => detail.sites.forEach(site => {
        const id = Number(site.siteIdentifierRegistryId);
        if (Number.isFinite(id) && id > 0) ids.add(id);
        const guid = (site.siteGuid || "").trim().toLowerCase();
        if (guid) guids.add(guid);
        const identifier = (site.siteIdentifier || "").trim().toLowerCase();
        if (identifier) identifiers.add(identifier);
    }));
    return { siteIds: [...ids], siteGuids: [...guids], siteIdentifiers: [...identifiers] };
}

export const hasHomeSiteScope = (scope: HomeSiteScope): boolean =>
    !!(scope.siteIds.length || scope.siteGuids.length || scope.siteIdentifiers.length);
